import React from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
import { PurchaseCTA } from './PurchaseCTA';
const items = [{
  title: 'Baraja Sistémica de Constelación Familiar (250 Cartas) + Manual de Aplicación',
  description: 'Set de 250 cartas terapéuticas diseñado para identificar patrones familiares invisibles, comprender bloqueos emocionales y facilitar movimientos de sanación, acompañado de un manual práctico para usar desde la primera sesión.',
  image: 'https://cdn.magicpatterns.com/uploads/vPpVN3RWPTwoBHjt2fnkyY/Diseno_sin_titulo_(7)_(4).webp'
}, {
  title: 'Diario Terapéutico de Integración Sistémica',
  description: 'Cuaderno de acompañamiento para que el consultante registre emociones, descubrimientos, reflexiones y cambios internos luego de cada sesión de Constelación Familiar.',
  image: 'https://cdn.magicpatterns.com/uploads/nemGPti3XNmzZzn19RwNFf/Diseno_sin_titulo_(8).webp'
}, {
  title: 'Guía Práctica de Resolución de Conflictos Familiares',
  description: 'Métodos simples y efectivos para ayudar al terapeuta a abordar tensiones familiares con mayor claridad, armonía y reconciliación emocional.',
  image: 'https://cdn.magicpatterns.com/uploads/wh6xha6LKUkSFKsMyq2PfW/Diseno_sin_titulo_(9).webp'
}, {
  title: 'Constelación Sistémica de la Prosperidad + Oráculo de Abundancia Familiar (50 Cartas)',
  description: 'Herramienta terapéutica orientada a liberar bloqueos heredados relacionados con dinero, merecimiento y prosperidad, conectando linaje familiar y abundancia.',
  image: 'https://cdn.magicpatterns.com/uploads/hErsPFLcZFZ9rAeAVmK1mJ/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil.webp'
}, {
  title: 'Fichas Profesionales de Anamnesis Sistémica (Constelación + Genograma) – Editables en Canva',
  description: 'Plantillas profesionales personalizables para registrar historia familiar, vínculos emocionales, repeticiones generacionales y dinámicas sistémicas con orden visual.',
  image: 'https://cdn.magicpatterns.com/uploads/u5cPSUTk39hQ5d2kyRPU9K/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(1).webp'
}, {
  title: 'Guía Visual de Genograma Terapéutico + Cartas de Afirmaciones Sistémicas Sanadoras',
  description: 'Manual paso a paso para crear genogramas familiares en consulta y detectar patrones ocultos, acompañado de cartas con afirmaciones restauradoras.',
  image: 'https://cdn.magicpatterns.com/uploads/8GSveiomGzQ3kXkuhcVpma/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(2).webp'
}, {
  title: 'Gestalt Sistémica en Sesión – 350 Preguntas Terapéuticas',
  description: 'Colección de preguntas profundas para expandir la conciencia del cliente, desbloquear emociones reprimidas y revelar movimientos inconscientes del sistema familiar.',
  image: 'https://cdn.magicpatterns.com/uploads/ceotCNu32jicTK8AHBhkmr/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(3).webp'
}, {
  title: 'Guion Profesional de Sesión de Constelación Familiar',
  description: 'Estructura completa de sesión que guía desde la apertura del campo sistémico hasta el cierre emocional e integración final del proceso.',
  image: 'https://cdn.magicpatterns.com/uploads/oUhjGv3YFmhN7pBXksPDo9/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(4).webp'
}, {
  title: 'Checklist de Preparación Energética del Constelador',
  description: 'Lista práctica para prepararte antes de cada sesión con ejercicios de respiración, intención, limpieza energética y enfoque terapéutico.',
  image: 'https://cdn.magicpatterns.com/uploads/kufUnrk4PcccSFstHYpqm7/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(5).webp'
}, {
  title: 'Planilla de Seguimiento Terapéutico del Cliente',
  description: 'Sistema organizado para registrar avances, sesiones realizadas, evolución emocional y resultados visibles de cada proceso terapéutico.',
  image: 'https://cdn.magicpatterns.com/uploads/dMyZFz2hbqbVbdXHLuwzfP/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(6).webp'
}];
export function WhatYouReceive() {
  return <section className="relative overflow-hidden bg-[#fdfbf7] py-16 md:py-24" data-id="element-426" data-mp="uefz1ikl37or">
      <div className="pointer-events-none absolute right-0 top-0 h-80 w-80 -translate-y-1/2 translate-x-1/2 rounded-full bg-[#eee5f7] opacity-70 blur-3xl" data-id="element-427" data-mp="zadg5r3o8i2l" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-80 w-80 translate-y-1/2 -translate-x-1/2 rounded-full bg-[#f3eadc] opacity-80 blur-3xl" data-id="element-428" data-mp="6lpondsbwwgl" />

      <div className="relative z-10 mx-auto max-w-5xl px-4" data-id="element-429" data-mp="bnyfa3hqbmfj">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.35,
        ease: [0.23, 1, 0.32, 1]
      }} className="mb-10 text-center" data-id="element-430" data-mp="foqs16pt89gk">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-6 inline-flex items-center gap-2 rounded-full bg-[#eee5f7] px-4 py-1.5 text-xs font-black uppercase tracking-widest text-[#4b257a]" data-id="element-431" data-mp="3o27751c6uvm9">
            <Sparkles size={14} data-id="element-432" data-mp="34fj1puqpx4a2" />
            <span data-id="element-433" data-mp="30de98zc0adp0">Tu Transformación Profesional</span>
          </motion.div>

          <h2 className="mb-4 font-['Playfair_Display',_serif] text-4xl font-bold text-[#2e1065] md:text-6xl" data-id="element-434" data-mp="30bb8bk9bf05i">
            Todo lo que recibís <br className="hidden md:block" data-id="element-435" data-mp="39ecc3eapkf60" />
            <span className="text-[#6b4fa0]" data-id="element-436" data-mp="39cj6817x5yz2">al acceder hoy</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-6" data-id="element-437" data-mp="2lmx8zjb3xttp">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group flex min-h-full flex-col rounded-2xl border border-[#e8decf] bg-white p-3 shadow-[0_12px_24px_-20px_rgba(46,16,101,0.7)] transition-[transform,box-shadow,border-color] duration-200 ease-out hover:-translate-y-0.5 hover:border-[#cfc0e4] hover:shadow-[0_18px_30px_-18px_rgba(46,16,101,0.45)] md:rounded-3xl md:p-5" data-id="element-438" data-mp="2gnc8h4gahdev" data-mpi={index}>
              {item.image && <div className="mb-3 overflow-hidden rounded-xl bg-[#f5f0ea] md:mb-5 md:rounded-2xl" data-id="element-439" data-mp="1aupghk99h5n6">
                  <img src={item.image} alt={item.title} className="w-full h-auto object-cover transition-transform duration-200 ease-out group-hover:scale-[1.02]" data-id="element-440" data-mp="3qltv3xupq7rf" />
                </div>}
              <div className="flex items-start gap-2 md:gap-3" data-id="element-441" data-mp="m4sjlau3q7d7">
                <CheckCircle2 className="mt-0.5 shrink-0 text-[#b78b31]" size={17} data-id="element-442" data-mp="h68tqzce0bfk" />
                <div data-id="element-443" data-mp="c8phg4z928q9">
                  <h3 className="text-[13px] font-bold leading-snug text-[#2e1065] md:text-lg" data-id="element-444" data-mp="c98sr2ue9yvb">
                    {item.title}
                  </h3>
                  <p className="mt-2 hidden text-sm leading-relaxed text-[#665873] md:block" data-id="element-445" data-mp="14vtftr3u7ot2">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-446" data-mp="v606yxv2xnsi">
          <PurchaseCTA label="Quiero mi sistema completo" data-id="element-447" data-mp="1sm7bdrlms5se" />
          <p className="mx-auto mt-5 max-w-2xl font-['Playfair_Display',_serif] text-lg italic text-[#51405f] md:text-xl" data-id="element-448" data-mp="1snqtlnqukqwt">
            "No es solo una guía, es el mapa sistémico para ordenar tu historia
            y potenciar tu mirada como facilitador profesional."
          </p>
        </div>
      </div>
    </section>;
}